// useDraggableTask.js - Hook for making tasks draggable using native HTML5 drag and drop
import { useCallback, useContext } from 'react';
import { GanttDndContext } from '../context/GanttDndContext';

export const useDraggableTask = (task, category) => {
  const { setDraggingTask, isEditMode } = useContext(GanttDndContext);

  // Don't allow dragging completed tasks
  const isCompleted = task.state === 'COMPLETED';
  const isDraggable = isEditMode && !isCompleted;

  const handleDragStart = useCallback((event) => {
    // Only allow dragging in edit mode and if task is not completed
    if (!isEditMode || isCompleted) {
      event.preventDefault();
      return;
    }

    // Set the drag data
    event.dataTransfer.effectAllowed = 'move';
    event.dataTransfer.setData('application/json', JSON.stringify({
      task,
      category,
    }));

    // Set a custom drag image (optional)
    const dragImage = event.currentTarget.cloneNode(true);
    dragImage.style.opacity = '0.8';
    event.dataTransfer.setDragImage(event.currentTarget, 0, 0);

    // Update context state
    setDraggingTask({ task, category });
  }, [task, category, setDraggingTask, isEditMode, isCompleted]);

  const handleDragEnd = useCallback((event) => {
    // Clear dragging state
    setDraggingTask(null);
  }, [setDraggingTask]);

  return {
    draggable: isDraggable,
    onDragStart: handleDragStart,
    onDragEnd: handleDragEnd,
  };
};
